import script from "./InterestModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./InterestModal.vue?vue&type=script&lang=ts&setup=true"

import "./InterestModal.vue?vue&type=style&index=0&id=16d0b610&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16d0b610"]])

export default __exports__